<section class="information-panel" [attr.aria-label]="title">
  <header>
    <mat-icon aria-hidden="true">info</mat-icon>
    <h2>{{ title }}</h2>
  </header>
  <p [innerHTML]="description"></p>
</section>
